import { render, staticRenderFns } from "./EditZoneBarca.vue?vue&type=template&id=55f2a9e2&scoped=true&"
import script from "./EditZoneBarca.vue?vue&type=script&lang=js&"
export * from "./EditZoneBarca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f2a9e2",
  null
  
)

export default component.exports